import MessageQueue from '../../../../services/MessageQueue';
import EditorStateMachine from '../../model/EditorStateMachine';

class IframeEventsManager {
  private hostMousemoveHandler: (event: MouseEvent) => void;

  private removeEvents = [];

  public initEvents() {
    this.hostMousemoveHandler = (event: MouseEvent) => {
      EditorStateMachine.transition('onIdle', {});
    };
    document.addEventListener('mousemove', this.hostMousemoveHandler);
  }

  public addEvent(eventName: string, callback: (event: any) => void) {
    this.removeEvents.push(MessageQueue.on(eventName, callback));
  }

  public clearEvents() {
    this.removeEvents.forEach((removeEvent) => {
      removeEvent();
    });

    document.removeEventListener('mousemove', this.hostMousemoveHandler);
  }
}

export default new IframeEventsManager();
